<div class="search-page">
  <div class="filters-m mobile">
    <div class="icon-options">
      <button (click)="openSortDialog()"><i class="fas fa-exchange-alt sort-arrows"></i> <span>Sort</span></button>
      <button class="map-list" (click)="changeCurrentView()">
        <img
          src="{{
            currentView === 'list' ? 'assets/images/search/map-icon.svg' : 'assets/images/search/list-icon.svg'
          }}"
          alt="" />
        <span>{{ currentView === 'list' ? 'Map' : 'List' }}</span>
      </button>
      <button (click)="openFilters()"><i class="fa-solid fa-sliders"></i> <span>Filters</span></button>
    </div>
  </div>
  <div class="search-container">
    <div class="filter-search">
      <div class="filters desktop">
        <div class="sort-options">
          <div class="filter-box filtered select" #sortFilterBox>
            <span>
              <button #sortTrigger="matMenuTrigger" (click)="openSortingMenu()" [matMenuTriggerFor]="sortingMenu">
                Sort by
              </button>
              {{ getSortByName() }}
            </span>
          </div>
          <mat-menu #sortingMenu="matMenu" class="filter-menu" [hasBackdrop]="false">
            <ul class="custom-quick-filter-list">
              <ng-container *ngFor="let item of sortList">
                <li (click)="sortBy(item.value)">{{ item.name }}</li>
              </ng-container>
            </ul>
          </mat-menu>
          <div class="show-type" *ngIf="(service | slugText: 'lowercase' : 'yes') !== 'physiotherapy'">
            <div class="toggle-filter">
              <button [ngClass]="{ filtered: currentTab === 'In Person' }" (click)="onBookingTypeClick('In Person')">
                In Person
              </button>
              <button [ngClass]="{ filtered: currentTab === 'Online' }" (click)="onBookingTypeClick('Online')">
                Telehealth
              </button>
            </div>
          </div>
        </div>
        <div class="other-options">
          <div class="field-type-1 select">
            <label for="" class="field-label">Quick Filters:</label>
          </div>
          <!-- Earliest Available -->
          <div class="filter-box select" #availabilityFilterBox [ngClass]="{ filtered: getSelectedAvailability() }">
            <span>
              <button
                #availabilityTrigger="matMenuTrigger"
                (click)="openAvailabilityMenu()"
                [matMenuTriggerFor]="availabilityMenu">
                Availability
              </button>
              {{ getSelectedAvailability() }}
            </span>
            <img src="assets/images/x.svg" alt="Remove" (click)="clearSelection('earliest_availability')" />
          </div>
          <mat-menu #availabilityMenu="matMenu" class="filter-menu" [hasBackdrop]="false">
            <ul class="custom-quick-filter-list">
              <ng-container *ngFor="let item of earliestAvailList">
                <li (click)="quickFilterItemSelect(item, 'earliest_availability')">{{ item.name }}</li>
              </ng-container>
            </ul>
          </mat-menu>

          <!-- Distance -->
          <div
            class="filter-box select"
            #distanceFilterBox
            *ngIf="currentTab !== 'Online'"
            [ngClass]="{ filtered: getSelectedDistance() }">
            <span>
              <button #distanceTrigger="matMenuTrigger" (click)="openDistanceMenu()" [matMenuTriggerFor]="distanceMenu">
                Distance
              </button>
              {{ getSelectedDistance() }}
            </span>
            <img src="assets/images/x.svg" alt="Remove" (click)="clearSelection('distance_from_me')" />
          </div>
          <mat-menu #distanceMenu="matMenu" class="filter-menu" [hasBackdrop]="false">
            <ul class="custom-quick-filter-list">
              <ng-container *ngFor="let item of distanceList">
                <li (click)="quickFilterItemSelect(item, 'distance_from_me')">{{ item.name }}</li>
              </ng-container>
            </ul>
          </mat-menu>

          <div class="filter-box">
            <span>
              <button (click)="openFilters()">More Filters</button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="search-main-group">
      <div class="search-setting">
        <div class="search-body" *ngIf="!isMobile || (isMobile && currentView === 'list')">
          <div class="accordion" [ngClass]="{ expanded: expanded[1] }">
            <div class="accordion-header" (click)="toggleAccordion(1)">
              <div class="accordion-heading">
                <h4 class="accordion-title toggle-header">Practitioner Matching Preferences Questionnaire</h4>
              </div>
              <div class="icons">
                <img [ngClass]="{ 'rotate-arrow': expanded }" src="/assets/images/form/chevron-down.svg" alt="" />
              </div>
            </div>
            <form [formGroup]="preferenceForm" class="accordion-content">
              <div class="progress-bar-wrapper">
                <div class="progress-bar" [style.width.%]="getProgressPercent()"></div>
              </div>
              <!-- Step Content -->
              <div class="step-content">
                <h2 class="head-text">Practitioner Matching Preferences Questionnaire</h2>

                <!-- STEP 0: Gender -->
                <div class="step" *ngIf="currentStep === 0">
                  <p class="step-label">Preferred Practitioner’s Gender</p>
                  <div class="options">
                    <button
                      type="button"
                      (click)="selectGender('male')"
                      [ngClass]="{ selected: genderCtrl.value === 'male' }">
                      Man
                    </button>
                    <button
                      type="button"
                      (click)="selectGender('female')"
                      [ngClass]="{ selected: genderCtrl.value === 'female' }">
                      Woman
                    </button>
                    <button
                      type="button"
                      (click)="selectGender('No Preference')"
                      [ngClass]="{ selected: genderCtrl.value === 'No Preference' }">
                      No Preference
                    </button>
                  </div>
                </div>

                <!-- STEP 1: Distance -->
                <div class="step" *ngIf="currentStep === 1">
                  <p class="step-label">Maximum Travel Distance Selection</p>
                  <div class="slider-wrapper">
                    <input
                      type="range"
                      min="1"
                      max="50"
                      [value]="distanceCtrl.value"
                      formControlName="distance_from_me"
                      (input)="updateSliderGradient($event)"
                      [style.background]="sliderBackground"
                      #slider />
                    <p class="sub-text">Within {{ distanceCtrl.value }} km</p>
                  </div>
                </div>

                <!-- STEP 2: Preferences -->
                <div class="step" *ngIf="currentStep === 2">
                  <div class="preference-section">
                    <div class="preference-set">
                      <p class="step-label">Preferred Appointment Times</p>
                      <div class="options">
                        <button
                          type="button"
                          (click)="onTimingChange('Morning')"
                          [ngClass]="{ selected: checkTimeEnabled('Morning') }">
                          Morning
                        </button>
                        <button
                          type="button"
                          (click)="onTimingChange('Afternoon')"
                          [ngClass]="{ selected: checkTimeEnabled('Afternoon') }">
                          Afternoon
                        </button>
                        <button
                          type="button"
                          (click)="onTimingChange('Evening')"
                          [ngClass]="{ selected: checkTimeEnabled('Evening') }">
                          Evening
                        </button>
                      </div>
                    </div>
                    <div class="preference-set">
                      <p class="step-label">Additional Needs</p>
                      <div class="options">
                        <button
                          type="button"
                          (click)="onAmenitiesChange('Wheelchair')"
                          [ngClass]="{ selected: checkAmenitiesEnabled('Wheelchair') }">
                          Wheelchair Access
                        </button>
                        <!-- <label class="custom-checkbox" [ngClass]="{'selected': amenitiesCtrl?.value}">
                              <input
                                type="checkbox"
                                formControlName="wheelchair"
                                (change)="additionalNeeds($event?.target?.checked)"
                              />
                              <span class="checkmark"></span>
                              Wheelchair access
                            </label> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="header">
                <div class="nav-buttons">
                  <button class="link-btn" (click)="onSkip()">Skip</button>
                  <button class="secondary-btn" *ngIf="currentStep > 0" (click)="onBack()">Back</button>
                  <button class="primary-btn" *ngIf="currentStep < maxStep" (click)="onNext()">Next</button>
                  <button class="primary-btn" *ngIf="currentStep === maxStep" (click)="refinePreferences()">
                    Refine Preferences
                  </button>
                </div>
              </div>
            </form>
          </div>
          <ul class="ct-breadcrumbs" *ngIf="!isMobile || (isMobile && currentView === 'list')">
            <li>
              <a routerLink="/">Home</a>
            </li>
            <ng-container *ngIf="service === 'health-and-wellbeing-services'; else elseTemplate">
              <li>
                <a>All</a>
              </li>
              <li>
                <a class="capitalize">{{ suburb | slugText: 'capitalize' }}</a>
              </li>
            </ng-container>
            <ng-template #elseTemplate>
              <li *ngIf="!checkIsSymtop()">
                <a [routerLink]="['/' + groupName]">{{ groupName | slugText: 'capitalize' }}</a>
              </li>
              <li *ngIf="routeType !== 'symptom'">
                <a [routerLink]="['/category/' + service]">{{ service | slugText: 'capitalize' }}</a>
              </li>
              <li *ngIf="routeType === 'symptom'">
                <a>{{ symptom | slugText: 'capitalize' }}</a>
              </li>
              <li>
                <a class="capitalize">{{ suburb | slugText: 'capitalize' }}</a>
              </li>
            </ng-template>
          </ul>
          <div class="heading">
            <h1 *ngIf="routeType !== 'symptom' && routeType !== 'online'">
              <i class="fa-solid fa-shield-halved"></i> Compare and book {{ totalItems }}
              {{
                professionTitle === 'All' || professionTitle === 'Alls'
                  ? 'Health and wellbeing' + (currentTab === 'practitioner' ? ' Practitioners' : ' Providers')
                  : professionTitle
              }}
              in {{ suburb | slugText: 'capitalize' : '' : '-' }}
            </h1>
            <h1 *ngIf="routeType === 'symptom'">
              Practitioners in {{ suburb | slugText: 'capitalize' : '' : '-' }} who treat
              {{ symptom | slugText: 'capitalize' : '' : '-' }}
            </h1>
            <h1 *ngIf="routeType === 'online'">
              Telehealth Services for {{ service | slugText: 'capitalize' : '' : '-' }}
            </h1>
          </div>
          <div class="search-wrapper">
            <div class="service-list" *ngIf="(isMobile && currentView === 'list') || !isMobile">
              <p class="loading" *ngIf="fetchingData">
                <i class="fa fa-spinner fa-spin"></i> Fetching
                {{ currentTab === 'practitioner' ? ' Practitioners' : ' Providers' }}...
              </p>
              <div class="loading" *ngIf="nodata">
                <p>No {{ currentTab === 'practitioner' ? ' practitioners' : ' providers' }} available...</p>
                <button (click)="openMobilePop()">Update Search</button>
              </div>

              <!-- PRACTITIONER LIST GROUP -->
              <ng-container *ngFor="let practitioner of practitionerList">
                <!-- <app-testing-comp [partner]="practitioner" [selectedDate]="selectedDate"></app-testing-comp> -->
                <app-search-item-practitioner
                  (mouseleave)="onMouseOut(practitioner, 'practitioner')"
                  (mouseenter)="onMouseEnter(practitioner, 'practitioner')"
                  [partner]="practitioner"
                  [selectedDate]="selectedDate"
                  [bookingType]="currentTab"></app-search-item-practitioner>
              </ng-container>
              <button
                class="more-btn"
                (click)="fetchRemainingPractitioners()"
                *ngIf="!fetchingData && totalItems - pageNumber * pageSize > 0"
                [disabled]="fetchingmoreData">
                <i *ngIf="fetchingmoreData" class="fa fa-spin fa-spinner"></i>Show
                {{ totalItems - pageNumber * pageSize }} more
              </button>
            </div>

            <ng-container *ngIf="routeType === 'category'">
              <app-for-category [service]="service"></app-for-category>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="map-view" *ngIf="(isMobile && currentView === 'map') || !isMobile">
        <ng-container *ngIf="centerCoords?.[0] || centerCoords?.[1]">
          <app-map-view
            [selectedDate]="selectedDate"
            [bounds]="mapBounds"
            [fitNonce]="fitBoundsNonce"
            [bookingType]="currentTab"
            [coordinatesList]="{ list: mapBizList, center: centerCoords }"
            [hoveringCard]="hoverredBusiness"
            (clickedBiz)="goToBusiness($event)"
            (updateCoordinates)="updateCoordinates($event)"></app-map-view>
        </ng-container>
      </div>
    </div>
  </div>
</div>
